export default "__VITE_PUBLIC_ASSET__9a91115b__"